import React from "react";
import logo from "../../assets/images/logo_orange.svg";

const AstronomicLogo = () => {
  return (
    <img className="astronomic-logo" src={logo} alt="Astronomic Network Logo" />
  );
};

export default AstronomicLogo;
